import React from 'react'

import { Box } from '@chakra-ui/react'

export type KebabVerticalIconProps = {
  size?: number
  color?: string
  colorScheme?: string
  className?: string
}

export const KebabVerticalIcon = ({
  size = 20,
  colorScheme,
  color,
  className,
}: KebabVerticalIconProps) => (
  <Box
    alignItems='center'
    color={
      color ??
      (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
    }
    display='flex'
  >
    <svg
      aria-label='More options'
      className={className}
      fill='currentColor'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='10' cy='2' r='2' />
      <circle cx='10' cy='10' r='2' />
      <circle cx='10' cy='18' r='2' />
    </svg>
  </Box>
)
